export enum QrCodeReaderType {
  Scanner = 1,
  Camera = 2,
}

export interface Workstation {
  id: number;
  terminalNumber: number;
  hasFobReader: boolean;
  qrCodeReaderType: QrCodeReaderType;
  hasReceiptPrinter: boolean;
  hasSession: boolean;
  hideTables: boolean;
  isSessionBlockNewTransactions: boolean;
  offlineAvailable?: boolean | null;
  isAppTill: boolean;
  requireTableToCompleteTransaction: boolean;
  workstationLocationId: number | null;
  workstationLocationName: string | null;
}
